import React from "react";
import type { Film } from "../../types/film";
export function ReelCard({
  film
}: {
  film: Film;
}) {
  return <article className="reel-card group/card relative" tabIndex={0} aria-label={`${film.tag}: ${film.title}`} data-id="element-47" data-mp="3ambf65j70u12">
      <div className="relative aspect-[9/16] overflow-hidden rounded-[12px] bg-card" data-id="element-48" data-mp="3olta72n313iv">
        <img src={film.image} alt={film.alt} loading="lazy" className="h-full w-full object-cover brightness-[0.6] transition-[transform,filter] duration-[250ms] ease-out group-hover/card:scale-[1.04] group-hover/card:brightness-100 group-focus/card:brightness-100" data-id="element-49" data-mp="3jp2sybzjk1vv" />
        <span className={`absolute left-2.5 top-2.5 rounded-[8px] px-2 py-1 font-mono text-[10px] tracking-[0.1em] ${film.tag === "REEL" ? "bg-black/60 text-white" : "bg-signal text-ink"}`} data-id="element-50" data-mp="35pur1bbzufnz">
          {film.tag}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3 opacity-0 transition-opacity duration-200 group-hover/card:opacity-100 group-focus/card:opacity-100 [@media(hover:none)]:opacity-100" style={{
        background: "linear-gradient(0deg, rgba(0,0,0,0.85), rgba(0,0,0,0))"
      }} data-id="element-51" data-mp="289nx5bj2jg2c">
          <p className="font-serif text-[18px] leading-tight text-white" data-id="element-52" data-mp="2uhw3w8g47h9x">{film.title}</p>
          <p className="mt-1 font-mono text-[10px] tracking-[0.08em] text-white/70" data-id="element-53" data-mp="2yk95qlrqqv1f">{film.meta}</p>
          <div className="mt-2.5 h-[2px] w-full bg-white/25" data-id="element-54" data-mp="21u06t2mmvncm">
            <div className="reel-progress h-full w-full bg-signal" data-id="element-55" data-mp="21vjmar0gtudc" />
          </div>
        </div>
      </div>
    </article>;
}